"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Atom = void 0;
const boolean_literal_1 = require("../../../../#lib/expression-tree/nodes/boolean-literal");
const date_literal_1 = require("../../../../#lib/expression-tree/nodes/date-literal");
const identifier_1 = require("../../../../#lib/expression-tree/nodes/identifier");
const null_literal_1 = require("../../../../#lib/expression-tree/nodes/null-literal");
const number_literal_1 = require("../../../../#lib/expression-tree/nodes/number-literal");
const reg_exp_literal_1 = require("../../../../#lib/expression-tree/nodes/reg-exp-literal");
const string_literal_1 = require("../../../../#lib/expression-tree/nodes/string-literal");
const uuid_literal_1 = require("../../../../#lib/expression-tree/nodes/uuid-literal");
const field_1 = require("../../../../#lib/field");
const uuid_1 = require("../../../../#lib/uuid");
const syntax_exception_1 = require("../syntax-exception");
const syntax_kind_1 = require("../syntax-kind");
const ast_node_1 = require("./ast-node");
class Atom extends ast_node_1.AstNode {
    constructor(kind, token) {
        super(kind);
        this.children = [];
        this.token = token;
    }
    get null() {
        this.assertKind(syntax_kind_1.SyntaxKind.NullLiteral);
        return null;
    }
    get boolean() {
        this.assertKind(syntax_kind_1.SyntaxKind.BooleanLiteral);
        return JSON.parse(this.token);
    }
    get number() {
        this.assertKind(syntax_kind_1.SyntaxKind.NumberLiteral);
        return JSON.parse(this.token);
    }
    get string() {
        this.assertKind(syntax_kind_1.SyntaxKind.StringLiteral);
        return JSON.parse(this.token);
    }
    get date() {
        this.assertKind(syntax_kind_1.SyntaxKind.DateLiteral);
        return new Date(this.token);
    }
    get regExp() {
        this.assertKind(syntax_kind_1.SyntaxKind.RegExpLiteral);
        const pattern = /\/((?:\\.|[^/\\])*)\/([a-z]*)/;
        const result = pattern.exec(this.token);
        return new RegExp(result[1], result[2]);
    }
    get uuid() {
        this.assertKind(syntax_kind_1.SyntaxKind.UuidLiteral);
        return uuid_1.uuid(this.token);
    }
    get value() {
        switch (this.kind) {
            case syntax_kind_1.SyntaxKind.NullLiteral:
                return this.null;
            case syntax_kind_1.SyntaxKind.BooleanLiteral:
                return this.boolean;
            case syntax_kind_1.SyntaxKind.NumberLiteral:
                return this.number;
            case syntax_kind_1.SyntaxKind.StringLiteral:
                return this.string;
            case syntax_kind_1.SyntaxKind.DateLiteral:
                return this.date;
            case syntax_kind_1.SyntaxKind.RegExpLiteral:
                return this.regExp;
            case syntax_kind_1.SyntaxKind.UuidLiteral:
                return this.uuid;
            default:
                throw new syntax_exception_1.SyntaxException();
        }
    }
    toExpressionTreeNode() {
        switch (this.kind) {
            case syntax_kind_1.SyntaxKind.NullLiteral:
                return new null_literal_1.NullLiteral();
            case syntax_kind_1.SyntaxKind.BooleanLiteral:
                return new boolean_literal_1.BooleanLiteral(this.boolean);
            case syntax_kind_1.SyntaxKind.NumberLiteral:
                return new number_literal_1.NumberLiteral(this.number);
            case syntax_kind_1.SyntaxKind.StringLiteral:
                return new string_literal_1.StringLiteral(this.string);
            case syntax_kind_1.SyntaxKind.DateLiteral:
                return new date_literal_1.DateLiteral(this.date);
            case syntax_kind_1.SyntaxKind.RegExpLiteral:
                return new reg_exp_literal_1.RegExpLiteral(this.regExp);
            case syntax_kind_1.SyntaxKind.UuidLiteral:
                return new uuid_literal_1.UuidLiteral(this.uuid);
            case syntax_kind_1.SyntaxKind.Identifier:
                return new identifier_1.Identifier(new field_1.Field(this.token));
            default:
                throw new syntax_exception_1.SyntaxException();
        }
    }
    assertKind(kind) {
        if (this.kind !== kind) {
            throw new syntax_exception_1.SyntaxException();
        }
    }
}
exports.Atom = Atom;
//# sourceMappingURL=atom.js.map